import { isNotUndefined } from "../utils/dictionaries";

export type Gene = {
  trait: GeneTrait;
  weight: number;
};

export enum GeneTrait {
  STRONG = "STRONG",
  AGILE = "AGILE",
  FERTILE = "FERTILE",
  WEAK = "WEAK", //@TODO prevent addition of gene from same family (ex: STONG/WEAK)
}

//@TODO: initial genes selection should be a list of all possible genes (ALLGENES) + initial weight
// THEN geneSelection(crossGenes(ALLGENES)) either for genesLatent or genes (latent to keep the maximum possibilities)

export const createGene = (trait: GeneTrait): Gene => {
  return {
    trait,
    weight: 1,
  };
};

export const removeDuplicate = (arr: Gene[]): Gene[] => {
  return arr.filter((g, i) => arr.indexOf(g) === i);
};

export const crossGenes = (gA: Gene[], gB: Gene[]): Gene[] => {
  /*const gAB = removeDuplicate(
    [
      ...gA.map((g) => (Math.random() < g.weight ? g : undefined)),
      ...gB.map((g) => (Math.random() < g.weight ? g : undefined)),
    ].filter(isNotUndefined)
  );*/

  const mutate = (g: Gene): Gene => {
    return Math.random() < 0.33 ? { ...g, weight: g.weight * 1.2 } : g;
  };

  const reduceSumGenes = (gRes: Gene[], gene: Gene) => {
    const currG = gRes.find((e) => e.trait === gene.trait);
    if (!currG) {
      return [...gRes, gene];
    }

    //@TODO: genes apprearance/mutation

    return [
      ...gRes.filter((g) => g.trait !== gene.trait),
      { ...currG, weight: currG.weight + gene.weight },
    ];
  };

  const gAB = [...gA, ...gB]
    .reduce(reduceSumGenes, []) //add parent genes
    .map((g) => ({ ...g, weight: g.weight * 0.6 })) //weaken genes
    .filter((g) => g.weight > 0.01); //remove too weak genes

  return gAB;
};

export const geneSelection = (genes: Gene[]): Gene[] => {
  return genes.filter((g) => Math.random() < g.weight);
};

//IDEE:
/*
- MUTATION change a GENE version 
- Each version roll a new modifier value (can be either malus/bonus) and store it to worldstate
- bonus/malus should change the gene label (ex: STRONG/WEAK) + concat with version id
- action only take a list of GeneTrait without knowledge if it will be bonus/malus
- Hence: modifier operators should be standard (mult / add / etc...)
- when several versions of same GENE, roll of which gene is retrieved should be geneA.weight/geneA.weight + geneB.weight
*/
